const baseUrl = 'https://iuyum-batch.aysbulut.com/api';

export const batchUrl = {
    getCompanyList: `${baseUrl}/luca/getCompanyList`,
    getEledgerLog: `${baseUrl}/luca/getEledgerLog`,
    createCompanies: `${baseUrl}/luca/createCompanies`,
    updateLucaCredentials: `${baseUrl}/luca/updateLucaCredentials`,
    batchLucaReceipt: `${baseUrl}/luca/batchLucaReceipt`,
    batchStatus: `${baseUrl}/luca/batch`,
    restartFailedSessions: `${baseUrl}/luca/restart-failed-sessions`,
    getBatchs: `${baseUrl}/luca/getBatchs`,
    updateSession: `${baseUrl}/luca/batch/update-session`,
    updateCompany: `${baseUrl}/luca/batch/update-company`,
    sendCertificate: `${baseUrl}/luca/batch/send-certificate`
};

export const legder = {
    ledgerView: `${baseUrl}/ledger-view`,
    reportData: `${baseUrl}/ledger-view/report-data`
};
